<template>
    <div class="layout__padding-clear">
        <div class="text__align-center text__colour-teal layout__margin__bottom-25px colour__background__grey-f7f8fa">
            <div class="layout__padding-clear layout__padding-20px">
                <div class="text__colour-teal text__size-45 text__style-bold-700">Direct Mail</div>
            </div>
        </div>

        <div class="layout__padding-clear layout__width-80">
            <div class="component__columns-2 layout__margin-20-0">
                <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/directmailer.jpg" class="layout__width-90 layout__padding__bottom-25px">
            </div>
            <div class="component__columns-2 layout__margin-20-0">
                <h3 class="text__colour-teal text__style-bold-900">In a fast paced, 24-hours-a-day digital world, we’re noticing that direct mail is quietly making a big come back.</h3>

                <div class="text__size-16 text__colour-grey layout__padding-20-0 text__line-height-20px">
                    Direct mail not only helps you reach out to potential customers but it can build rapport with existing clients and build brand recognition.
                </div>

                <div class="text__size-16 text__colour-grey text__line-height-20px">
                    Targeting and personalisation can make the difference between success and failure for direct mail.
                </div>

                <div class="text__size-16 text__colour-grey layout__padding-20-0 text__line-height-20px">
                    Increase response rates with our comprehensive data set all available via Marketing Toolkit and Directmailr<span class="text__size-8 layout__position-top">TM</span>
                </div>

                <div class="text__size-16 text__colour-teal text__line-height-20px">
                    We now have lower Direct Mail rates for the following products:
                </div>

                <div class="text__size-16 text__colour-grey layout__padding-20-0 text__line-height-20px">
                    A5 Flyer – 2 pages printed on 350gsm<br>
                    Silk with a Matt Lamination: <span class="text__colour-red">Now £0.47</span>
                </div>
                <div class="text__size-16 text__colour-grey text__line-height-20px">
                    A4 Letter – 1 page printed on 120gsm<br>
                    Uncoated folded &amp; placed in a C5 envelope: <span class="text__colour-red">Now £0.64</span>
                </div>


                <div class="layout__padding-20-0">
                    <el-button class="layout__width-230px button-red layout__margin__right-20px" v-on:click="instantPrint()">
                        I've got print ready artwork
                    </el-button>
                    <el-button class="layout__width-200px button-red"
                               v-on:click="contactUs()">I need this designed
                    </el-button>
                </div>
            </div>
        </div>

        <div class="layout__padding-20px colour__background__grey-f7f8fa layout__padding-clear layout__overflow-hidden">
            <div class="text__size-30 text__align-center text__colour-teal text__style-bold-900 layout__padding-20px">
                You may also like
            </div>

            <div class="layout__width-80 layout__padding-clear">

                <router-link class="link__colour-black" to="/products/digital/web-banners">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/web-banner-720x500.png" class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Web Banners</div>
                        </div>
                    </div>
                </router-link>

                <router-link class="link__colour-black" to="/products/digital/microsites">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/micrositemockup.jpg" class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Microsites</div>
                        </div>
                    </div>
                </router-link>

                <router-link class="link__colour-black" to="/products/digital/animated-brochure">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/animated-brochure-720x500.png" class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Animated Brochure</div>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>


    </div>

</template>

<script>

    import Router from '../../router';

    export default {
        name: "SM",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            },
            instantPrint() {
                Router.push({
                    name: '/instant-print'
                });
            }
        }
    };
</script>
